import * as React from 'react'
import { Box, Drawer, IconButton } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { grey } from '@mui/material/colors'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'

import { getAssetURL } from 'lib/utility/GetAssetUrl'
import SidebarLinks from 'components/Sidebar/SidebarLinks'
import Help from 'components/Sidebar/DrawerFooter/Help'
import { ProfileOptions } from 'components/Sidebar/DrawerFooter'

const MobileSidebar = () => {
  const [isOpen, onOpen] = React.useState(false)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [showProfileOptions, setProfileOptions] = React.useState<boolean>(false)

  const handleChange = () => {
    onOpen(!isOpen)
    showProfileOptions && setProfileOptions(false)
  }

  const handleProfileClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event?.currentTarget)
    setProfileOptions(!showProfileOptions)
  }

  const getHeader = () => (
    <Box sx={{ position: 'fixed', width: '100%', zIndex: 1299 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: 1,
          backgroundColor: grey[50],
        }}
      >
        <Box
          component="img"
          src={getAssetURL('/sidebar/engagement_logo.svg')}
          sx={{ width: '50%' }}
          alt="EngagementHQ"
        />
        <IconButton
          onClick={handleChange}
          size="medium"
          aria-label="SidebarIconButton"
        >
          <MenuIcon />
        </IconButton>
      </Box>
    </Box>
  )

  return (
    <Box
      sx={{
        display: {
          xs: 'block',
          sm: 'none',
        },
      }}
    >
      {getHeader()}

      <Drawer
        open={isOpen}
        anchor="right"
        hideBackdrop
        PaperProps={{
          sx: { width: '100%' },
        }}
      >
        <Box sx={{ mt: 8, pb: 8 }} role="button" onClick={handleChange}>
          <SidebarLinks
            isDrawerVisible={true}
            handleDropdownCollapse={handleChange}
          />
        </Box>
        <Box
          sx={{
            px: 2,
            py: 1,
            backgroundColor: grey[300],
            position: 'fixed',
            bottom: 0,
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'right',
              width: '100%',
            }}
          >
            <Box>
              <IconButton onClick={handleProfileClick}>
                <AccountCircleIcon fontSize="large" />
              </IconButton>

              <Box role="button" onClick={handleChange}>
                <ProfileOptions
                  anchorEl={anchorEl}
                  isPopperVisible={showProfileOptions}
                  onMobile
                />
              </Box>
            </Box>
            <Box sx={{ display: 'contents' }}>
              <Help hasIconOnly />
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  )
}

export default MobileSidebar
